module.exports = __webpack_public_path__ + "static/media/interactive.6eaafd1e.svg";